import React, { useContext, useEffect, useState } from "react";
import { faArrowLeft, faEdit } from "@fortawesome/free-solid-svg-icons";
import printheaderImage from "./images/IDC-HEADER.png";
import printfooterImage from "./images/IDC-FOOTER.png";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RoleContext } from "./App";
import LoaderAnimationMedium from "./LoaderAnimationMedium";

const ReportTemplate = ({
  loadingreportData,
  report_nid,
  permuser,
  patientDataTitle,
  patientDataDateOfBirth,
  patientDataGender,
  patientDataPatientID,
  referededBy,
  reportid,
  requestDataCreated,
  reportDataCreated,
  investigationsDataTitle,
  requestDataFieldClinicalDiagnosis,
  requestDataFieldComments,
  reportDataTitle,
  reportDataFieldReportTechnique = "",
  reportDataFieldReportFindings,
  reportDataFieldReportImpression,
  reporterDataFieldDoctorRefererfullname,
  reporterDataFieldSpecialty,
  noreportMessage,
  onClickAddReport,
  navigatingOnClickEdit,
}) => {
  // eslint-disable-next-line no-unused-vars
  const { activeRole, permissions } = useContext(RoleContext); // ✅ get everything

  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 1000); // 10 seconds delay

    return () => clearTimeout(timer);
  }, []);

  console.log("REPORT NODE ID", report_nid);
  console.log("IS LOADING REPORT STATE", loadingreportData);

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="add-patient-register">
          <TopActionMenus
            AddTitle={`Viewing CT Scan report`}
            distance={1}
            backIcon={faArrowLeft}
            backLable="Back"
          />
          <div className="patient-container">
            <div className="headerBlock">
              <img src={`${printheaderImage}`} alt="headerImage" />
            </div>

            <div className="topBlocksInfoWrapper">
              <div className="reportPatientName">
                <div className="itemblock">
                  <strong>Patient Full Name : </strong>
                  <h2>{patientDataTitle}</h2>
                </div>
                <div className="itemblock">
                  <strong>Patient ID : </strong>
                  <h2>{patientDataPatientID}</h2>
                </div>
              </div>
              <div className="reportDGPID">
                <div className="itemblock">
                  <strong>Date of Birth : </strong>
                  <h2>{patientDataDateOfBirth}</h2>
                </div>
                <div className="itemblock">
                  <strong>Gender : </strong>
                  <h2>{patientDataGender}</h2>
                </div>
                <div className="itemblock">
                  <strong>Requested By : </strong>
                  <h2>{referededBy}</h2>
                </div>
              </div>
              <div className="reportrequestDate">
                <div className="itemblock">
                  <strong>Report ID : </strong>
                  <h2>{reportid}</h2>
                </div>
                <div className="itemblock">
                  <strong>Request Date :</strong> <h2>{requestDataCreated}</h2>
                </div>
                <div className="itemblock">
                  <strong>Reported Date : </strong>
                  <h2>{reportDataCreated}</h2>
                </div>
              </div>
            </div>

            <div className="requestInfoWrapper">
              {/* Patient Clinical History Section */}
              <h2>Clinical History</h2>
              <h3>Investigation :</h3>

              <p>{investigationsDataTitle}</p>

              <h3>Clinical Diagnostic :</h3>
              <p>{requestDataFieldClinicalDiagnosis}</p>
              <h3>Comments :</h3>
              <p>{requestDataFieldComments}</p>
            </div>

            <div className="reportInfoWrapper">
              <div className="reportTitleNactionsWrapper">
                {!loadingreportData && (
                  <h3 className="reportTitle">{reportDataTitle}</h3>
                )}

                {report_nid && activeRole === "radiologist" && (
                  <div className="reportActions">
                    <button
                      className="reportEditLink"
                      onClick={navigatingOnClickEdit}
                    >
                      <span>Edit Report</span> <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </div>
                )}
              </div>

              {report_nid && (
                <>
                  {loadingreportData || showLoader ? (
                    <LoaderAnimationMedium loadingTxt="Loading..." />
                  ) : (
                    <>
                      <div className="techniqueBlock">
                        <h2>Technique :</h2>
                        <p>{reportDataFieldReportTechnique}</p>
                      </div>
                      <div className="findingsBlock">
                        <h2>Findings :</h2>
                        <p>{reportDataFieldReportFindings}</p>
                      </div>
                      <div className="impressionBlock">
                        <h2>Impression :</h2>
                        <p>{reportDataFieldReportImpression}</p>
                      </div>
                      <div className="signatureBlock">
                        <h3>{reporterDataFieldDoctorRefererfullname}</h3>
                        <h4>{reporterDataFieldSpecialty}</h4>
                      </div>
                    </>
                  )}
                </>
              )}

              <>
                {!report_nid &&
                  activeRole === "requester" &&
                  activeRole === "assigner" && (
                    <p className="no-reports">
                      Your report is currently being uploaded. Thank you for
                      waiting.
                    </p>
                  )}
              </>
              {!report_nid && activeRole === "radiologist" && (
                <p className="no-reports">
                  <button onClick={onClickAddReport}>Add Report</button>
                </p>
              )}
            </div>
            <div className="footerBlock">
              <img src={`${printfooterImage}`} alt="footerImage" />
            </div>
          </div>
        </div>
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default ReportTemplate;
